exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._1_xAn{-webkit-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-ms-flexbox;display:flex}._2wC4h{border-radius:50%;overflow:hidden;height:calc(42px + 1.83333vw);width:calc(42px + 1.83333vw)}@media (min-width:1200px){._2wC4h{height:64px;width:64px}}._1wN1E{height:auto;width:100%}._2MnUG{color:#5b5b5b;padding-left:1em}.X6Wh3{font-size:1.05em;font-weight:500;line-height:1}._1ed6M{font-size:.8em}", ""]);

// exports
exports.locals = {
	"root": "_1_xAn",
	"imgWrap": "_2wC4h",
	"img": "_1wN1E",
	"content": "_2MnUG",
	"leader": "X6Wh3",
	"leaderTitle": "_1ed6M"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--1-rules-2!./node_modules/postcss-loader/lib??ref--1-rules-3!./node_modules/sass-loader/lib/loader.js!./src/components/PartyProfile/PartyProfile.scss
// module id = 1044
// module chunks = 5